import React from 'react';
import styles from './CurrentDue.module.css';
import CardIcon from 'billing/CardIcon';

const CurrentPaymentMethod = ({ paymentMethod }) => {
  if (!paymentMethod) { return null; }

  return (
    <div className={styles.cardSummary}>
      <div className={styles.cardIcon}>
        <CardIcon cardType={paymentMethod.card_brand} color="dark" />
      </div>
      <div className={styles.cardBrand}>
        {paymentMethod.card_brand}
      </div>
      <div className={styles.lastFour}>
        •••• {paymentMethod.card_last_four}
      </div>
    </div>
  )
}

export default CurrentPaymentMethod;
